export const state = () => ({
  isLoadingVideos: false,
  activeCategoryId: '',
  activeVideoId: '',
  categoryIdShare: '',
  modalVisibility: {
    shareVideos: false,
  },
})

export const mutations = {
  toggleModal(state, modal) {
    state.modalVisibility[modal] = !state.modalVisibility[modal]
  },
  toggleLoadingVideos(state) {
    state.isLoadingVideos = !state.isLoadingVideos
  },
  setActiveCategoryId(state, categoryId) {
    state.activeCategoryId = categoryId
  },
  setActiveVideoId(state, videoId) {
    state.activeVideoId = videoId
  },
  setCategoryIdShare(state, categoryId) {
    state.categoryIdShare = categoryId
  },
}
